import { useGetDMaxCommon, type RoomDMaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";
import { useState } from "react";
import { RoomContents } from "./components/roomContents";

export const RoomsModal = ({ targetRoomIdx }: { targetRoomIdx: string }) => {
    const { data } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const [contentMode, setContentMode] = useState<"pic" | "info">("pic");

    return data ? (
        <Flex w="1280px" h="980px" p="24px" flexDir="column" gap="24px">
            <Flex
                sx={{
                    "& div": {
                        padding: "0 16px",
                        cursor: "pointer",
                        "& p": {
                            ...FONT("pretendard", 20, 500, 1.4),
                        },
                    },
                }}
            >
                <Box
                    onClick={() => setContentMode("pic")}
                    borderBottom={contentMode === "pic" ? "1px solid #3b6c8d" : "none"}
                >
                    <Text>객실사진</Text>
                </Box>
                <Box
                    onClick={() => setContentMode("info")}
                    borderBottom={contentMode === "info" ? "1px solid #3b6c8d" : "none"}
                >
                    <Text>객실정보</Text>
                </Box>
            </Flex>
            <Flex w="100%" flex="1">
                <RoomContents data={data} contentMode={contentMode} targetRoomIdx={targetRoomIdx} />
            </Flex>
        </Flex>
    ) : (
        <Center w="1280px" h="980px">
            <Text>Loading</Text>
            <Spinner />
        </Center>
    );
};
